var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.animaNumber)?_c('span',[_vm._v(" "+_vm._s(new Intl.NumberFormat('ru-RU').format(_vm.animaNumber.toFixed(0)))+" ₽ ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }